const createElement = () => {
    const element = document.createElement('div');
    element.className = 'svp_chromecast-status';

    return element;
};

const getDeviceName = () => {
    const session = cast.framework.CastContext.getInstance().getCurrentSession();
    if (!session) {
        return null;
    }

    const castDevice = session.getCastDevice();
    if (!castDevice) {
        return null;
    }

    return castDevice.friendlyName;
};

const isVideoIdLoadedOnChromecast = (videoId, player) => (
    player.isMediaLoaded &&
    player.mediaInfo &&
    player.mediaInfo.contentId === videoId
);

class ChromecastInfoComponent {
    constructor(player, controller, api) {
        this.element = createElement();
        this.player = player;
        this.controller = controller;
        this.context = cast.framework.CastContext.getInstance();
        this.api = api;

        this.controllerListeners = [];
        this.contextListeners = [];

        this.controllerListeners.push({
            type: cast.framework.RemotePlayerEventType.DISPLAY_NAME_CHANGED,
            handler: () => this.render()
        });

        this.controllerListeners.push({
            type: cast.framework.RemotePlayerEventType.MEDIA_INFO_CHANGED,
            handler: () => this.render()
        });

        this.controllerListeners.forEach(({ type, handler }) => {
            this.controller.addEventListener(type, handler);
        });

        this.contextListeners.push({
            type: cast.framework.CastContextEventType.CAST_STATE_CHANGED,
            handler: () => this.render()
        });

        this.contextListeners.forEach(({ type, handler }) => {
            this.context.addEventListener(type, handler);
        });

        this.render();
    }

    render() {
        const castState = this.context.getCastState();
        const deviceName = getDeviceName() || 'Okänd enhet';

        switch (castState) {
            case cast.framework.CastState.CONNECTING:
                this.element.innerHTML = 'Ansluter';
                this.element.style.display = 'block';
                break;
            case cast.framework.CastState.CONNECTED:
                if (isVideoIdLoadedOnChromecast(this.api.data().videoId, this.player)) {
                    this.element.innerHTML = `Spelas på ${deviceName}`;
                } else {
                    this.element.innerHTML = `Spela på ${deviceName}`;
                }
                this.element.style.display = 'block';
                break;
            default:
                this.element.style.display = 'none';
                break;
        }
    }

    destroy() {
        // Detach from DOM.
        if (this.element.parentNode) {
            this.element.parentNode.removeChild(this.element);
        }

        // Remove event listeners.
        while (this.controllerListeners.length > 0) {
            const { type, handler } = this.controllerListeners.shift();
            this.controller.removeEventListener(type, handler);
        }

        while (this.contextListeners.length > 0) {
            const { type, handler } = this.contextListeners.shift();
            this.context.removeEventListener(type, handler);
        }
    }
}

export default ChromecastInfoComponent;



// WEBPACK FOOTER //
// ./src/js/plugins/chromecast/chromecast-info-component.js